__turbopack_context__.v({
  "error": "Label-module__GgyI6W__error",
  "gutterBottom": "Label-module__GgyI6W__gutterBottom",
  "root": "Label-module__GgyI6W__root",
});
